import { Box, Circle, Flex, Img, Input, Text, Wrap } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import chat_Icon from "Assets/Inbox.svg";
import { addNewUser, findTalent, getUsers } from "services/api";
import { useWindow } from "hooks/useWindow";
import { useDispatch, useSelector } from "react-redux";
import { recruiterActions } from "redux/actions";
import { socket } from "socket";

const ChatList = ({ mobileView, setMobileView }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const type = user?.profile;
  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState([]);
  let talentsData = useSelector((state) => state?.recruiter?.talents);
  const navigate = useNavigate();
  const addUser = async (el) => {
    try {
      const res = await addNewUser({
        userId: JSON.parse(localStorage.getItem("user"))._id,
        name: el.name,
        image: el.profile_photo,
        jobTitle: el.jobTitle,
        consumerId: el?._id,
      });
      if (res.data.message?.includes("send message successfully")) {
        fetchUsers();
        setSearch([]);
        setSearchText("");
        navigate(`/hiring/recruiter/chat/${el._id}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const windowSize = useWindow();
  const fetchUsers = async () => {
    try {
      const { data } = await getUsers(user._id);
      setUsers(data.data?.reverse());
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (user?.profile === "recruiter") {
      const fetchData = async () => {
        try {
          dispatch(recruiterActions.clearTalent());
          const { data } = await findTalent("?search");
          dispatch(recruiterActions.setTalents(data.data));
        } catch (e) {
          console.log(e);
        }
      };
      fetchData();
    }
  }, []);

  return (
    <Flex
      flexDir={"column"}
      borderRight={windowSize > 500 && "1px solid #E4E4E4"}
      justify={"center"}
      w={mobileView ? "100%" : "21vw"}
      height={"100%"}
      m={"auto"}
      className={!mobileView ? "mobile-d-none" : ""}
    >
      {/* Title */}

      <Flex align={"center"} my={4} px={6} gap={2}>
        <Img src={chat_Icon} />
        <Text
          fontSize={24}
          fontFamily={"Epilogue"}
          color={"#544D5E"}
          fontWeight={700}
          mt={1}
        >
          Inbox
        </Text>
      </Flex>
      {/* Search Bar */}
      {user?.profile === "recruiter" && (
        <Flex p={4} justify={"space-between"} position={"relative"}>
          <Input
            type="text"
            placeholder="Search any Profile"
            onChange={(e) => {
              const value = e.target.value;
              setSearchText(value);

              if (value.length === 0) {
                setSearch([]);
                return;
              }
              const filteredUsers = talentsData?.filter((elem) => {
                return elem.name.toLowerCase().includes(value.toLowerCase());
              });
              setSearch(filteredUsers);
            }}
          ></Input>
          {search.length > 0 && searchText?.length > 0 && (
            <Flex
              position={"absolute"}
              background={"white"}
              zIndex={1}
              border={"1px solid #E4E4E4"}
              h={"200px"}
              w={"89%"}
              top={"57px"}
              overflow={"auto"}
              padding={2}
              gap={2}
              flexDir={"column"}
            >
              <Box>
                {search?.map((elem, idx) => {
                  return (
                    <Flex>
                      <a
                        onClick={() => {
                          addUser(elem);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          cursor: "pointer",
                          marginBottom: "5px",
                        }}
                      >
                        <Flex
                          h={51}
                          w={51}
                          borderRadius={"50%"}
                          border={"1px solid #E4E4E4"}
                        >
                          <Img src={elem.profile_photo} borderRadius={"50%"} />
                        </Flex>
                        <Text textTransform={"capitalize"}>{elem.name}</Text>
                      </a>
                    </Flex>
                  );
                })}
              </Box>
            </Flex>
          )}
        </Flex>
      )}
      {/* chatlist */}
      <Flex
        flexDir={"column"}
        h={"90vh"}
        css={{
          "::-webkit-scrollbar": {
            width: 0,
            height: 0,
          },
        }}
        overflow={"auto"}
        gap={2}
        px={4}
      >
        {users.length === 0 && (
          <Flex justify={"center"} align={"center"} h={"100%"}>
            No chats yet
          </Flex>
        )}
        {type === "ajna_student"
          ? users.map((elem, idx) => {
              return (
            
                <Flex
                  display={"block"}
                  onClick={() =>
                    windowSize < 768 &&
                    setMobileView((state) => {
                      return {
                        ...state,
                        chatList: false,
                      };
                    })
                  }
                >
                  <Link
                    to={`/hiring/student/chat/${
                      type === "ajna_student" && elem.userId
                    }`}
                  >
                    <Flex
                      align={"center"}
                      gap={4}
                      key={idx}
                      p={4}
                      borderBottom={" 1px solid #E7E6E8"}
                    >
                      <Flex>
                        <Img
                          h={51}
                          w={51}
                          src={elem.image}
                          borderRadius={"50%"}
                          alt="pic"
                          onError={(e) =>
                            (e.target.src = "https://fakeimg.pl/200x200/")
                          }
                        />
                      </Flex>
                      <Box>
                        {/* name */}
                        <Text
                          textTransform={"capitalize"}
                          textAlign={"left"}
                          fontSize={20}
                          fontFamily="Roboto"
                          fontWeight={600}
                        >
                          {elem.name}
                        </Text>
                        <Text textAlign={"left"}>
                          {elem.title || elem.jobTitle}
                        </Text>
                      </Box>
                    </Flex>
                  </Link>
                </Flex>
              );
            })
          : users?.map((elem, idx) => {
              return (
                <Flex
                  display={"block"}
                  onClick={() =>
                    windowSize < 768 &&
                    setMobileView((state) => {
                      return {
                        ...state,
                        chatList: false,
                      };
                    })
                  }
                >
                  <Link to={`/hiring/recruiter/chat/${elem.consumerId}`}>
                    <Flex
                      align={"center"}
                      gap={4}
                      key={idx}
                      p={4}
                      borderBottom={" 1px solid #E7E6E8"}
                    >
                      <Flex>
                        <Img
                          h={51}
                          w={51}
                          borderRadius={"50%"}
                          src={elem.image}
                          alt="pic"
                        />
                      </Flex>
                      <Box>
                        {/* name */}
                        <Text
                          textTransform={"capitalize"}
                          textAlign={"left"}
                          fontSize={20}
                          fontFamily="Roboto"
                          fontWeight={600}
                        >
                          {elem.name}
                        </Text>
                        <Text textAlign={"left"}>
                          {elem.title || elem.jobTitle}
                        </Text>
                      </Box>
                    </Flex>
                  </Link>
                </Flex>
              );
            })}
      </Flex>
    </Flex>
  );
};

export default ChatList;
